module.exports = __webpack_public_path__ + "media/images/distilation-desktop-ad89bee2b463668525c92c6445a94199.jpg";